var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductMasterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20817 2.91797C2.9165 2.91797 2.9165 3.0913 2.9165 5.20964V5.23047C2.9165 6.15297 2.9165 6.81964 3.14234 7.1013C3.36317 7.37464 4.019 7.5013 5.20817 7.5013C6.39734 7.5013 7.05317 7.3738 7.274 7.10047C7.49984 6.81964 7.49984 6.15297 7.49984 5.22964C7.49984 3.0913 7.49984 2.91797 5.20817 2.91797ZM5.20817 8.7513C3.80317 8.7513 2.749 8.6038 2.16984 7.88464C1.6665 7.26047 1.6665 6.4088 1.6665 5.23047L2.2915 5.20964H1.6665C1.6665 2.81797 1.81734 1.66797 5.20817 1.66797C8.599 1.66797 8.74984 2.81797 8.74984 5.20964C8.74984 6.40797 8.74984 7.26047 8.2465 7.88464C7.66734 8.6038 6.61317 8.7513 5.20817 8.7513Z",
    fill: "url(#paint0_linear_1798_40859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3747 2.91797C12.083 2.91797 12.083 3.0913 12.083 5.20964V5.23047C12.083 6.15297 12.083 6.81964 12.3088 7.1013C12.5297 7.37464 13.1855 7.5013 14.3747 7.5013C15.5638 7.5013 16.2197 7.3738 16.4405 7.10047C16.6663 6.81964 16.6663 6.15297 16.6663 5.22964C16.6663 3.0913 16.6663 2.91797 14.3747 2.91797ZM14.3747 8.7513C12.9697 8.7513 11.9155 8.6038 11.3363 7.88464C10.833 7.26047 10.833 6.4088 10.833 5.23047L11.458 5.20964H10.833C10.833 2.81797 10.9838 1.66797 14.3747 1.66797C17.7655 1.66797 17.9163 2.81797 17.9163 5.20964C17.9163 6.40797 17.9163 7.26047 17.413 7.88464C16.8338 8.6038 15.7797 8.7513 14.3747 8.7513Z",
    fill: "url(#paint1_linear_1798_40859)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20817 12.0859C2.9165 12.0859 2.9165 12.2593 2.9165 14.3776V14.3984C2.9165 15.3209 2.9165 15.9876 3.14234 16.2693C3.36317 16.5426 4.019 16.6693 5.20817 16.6693C6.39734 16.6693 7.05317 16.5418 7.274 16.2684C7.49984 15.9876 7.49984 15.3209 7.49984 14.3976C7.49984 12.2593 7.49984 12.0859 5.20817 12.0859ZM5.20817 17.9193C3.80317 17.9193 2.749 17.7718 2.16984 17.0526C1.6665 16.4284 1.6665 15.5768 1.6665 14.3984L2.2915 14.3776H1.6665C1.6665 11.9859 1.81734 10.8359 5.20817 10.8359C8.599 10.8359 8.74984 11.9859 8.74984 14.3776C8.74984 15.5759 8.74984 16.4284 8.2465 17.0526C7.66734 17.7718 6.61317 17.9193 5.20817 17.9193Z",
    fill: "url(#paint2_linear_1798_40859)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3747 12.0859C12.083 12.0859 12.083 12.2593 12.083 14.3776V14.3984C12.083 15.3209 12.083 15.9876 12.3088 16.2693C12.5297 16.5426 13.1855 16.6693 14.3747 16.6693C15.5638 16.6693 16.2197 16.5418 16.4405 16.2684C16.6663 15.9876 16.6663 15.3209 16.6663 14.3976C16.6663 12.2593 16.6663 12.0859 14.3747 12.0859ZM14.3747 17.9193C12.9697 17.9193 11.9155 17.7718 11.3363 17.0526C10.833 16.4284 10.833 15.5768 10.833 14.3984L11.458 14.3776H10.833C10.833 11.9859 10.9838 10.8359 14.3747 10.8359C17.7655 10.8359 17.9163 11.9859 17.9163 14.3776C17.9163 15.5759 17.9163 16.4284 17.413 17.0526C16.8338 17.7718 15.7797 17.9193 14.3747 17.9193Z",
    fill: "url(#paint3_linear_1798_40859)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40859",
    x1: 5.20817,
    y1: 1.66797,
    x2: 5.20817,
    y2: 8.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40859",
    x1: 14.3747,
    y1: 1.66797,
    x2: 14.3747,
    y2: 8.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40859",
    x1: 5.20817,
    y1: 10.8359,
    x2: 5.20817,
    y2: 17.9193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40859",
    x1: 14.3747,
    y1: 10.8359,
    x2: 14.3747,
    y2: 17.9193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMasterIcon);
export default __webpack_public_path__ + "static/media/product-master-icon.9fb2ac672335f5f43cfed9a753f224a4.svg";
export { ForwardRef as ReactComponent };